<app-top-bar title="PAYMENT.PAY_CARD" [customBack]="cancel"></app-top-bar>

<div [id]="dropinContainerId" class="dropin-container" [class.hidden]="loading"></div>

<app-loader-overlay [active]="loading"></app-loader-overlay>
